import styled from '@emotion/styled';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from '../../styles/basic';

const Wrapper = styled.div`
  display: block;
  p a {
    font-weight: bold;
    color: ${(props) => props.theme.mainColors.primary};
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary, 0)};
  }
`;

const BuyCoffeeImage = styled.img`
  display: block;
  width: 10rem;
  margin-bottom: 2rem;
`;

const ExplanationBox = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const ExplanationBoxNumber = styled.span`
  text-align: center;

  > b {
    display: block;
    width: 4rem;
    font-size: 4rem;
    line-height: 1;
    color: ${(props) => props.theme.mainColors.primary};
  }
  > span {
    display: block;
    text-transform: uppercase;
  }
  & + & {
    b {
      border-left: .1rem solid ${(props) => props.theme.mainColors.secondary};
    }
  }
`;

const Figure = styled.figure`
  display: block;
  overflow: hidden;
  margin: 0 0 2rem;
  color: ${(props) => props.theme.color.darkGray};
  text-align: right;

  @media (min-width: ${breakpoints.smallTablet}) {
    float: right;
    width: 44%;
    margin: 0 0 2rem 2rem;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    margin-bottom: 4rem;
    margin-left: 4rem;
  }

  @media (min-width: ${breakpoints.smallLaptop}) {
    margin-left: 2rem;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
`;

export {
  Wrapper,
  BuyCoffeeImage,
  ExplanationBox,
  ExplanationBoxNumber,
  Figure,
  Image
};
